var fn = function( obj ){
var __t,__p='';
__p+='\nuniform sampler2D tFloorReflect;';
return __p;
};
fn.toString=fn;
module.exports = fn;